// @flow strict

import * as React from 'react';
import type { ResourceType } from '../types';
import PageContentBlock from '../../../../internal/PageContentBlock';
import { Columns, LinkColumn } from '../../../../internal/Columns';

export default (props: { resources: Array<ResourceType>, title: string }) => {
  if (props.resources.length === 0) {
    return null;
  }

  return (
    <PageContentBlock title={props.title}>
      <Columns columns={3}>
        {props.resources.map((resource, index) => (
          /* eslint-disable react/no-array-index-key */
          <LinkColumn
            key={index}
            image={resource.image}
            title={resource.title}
            text={resource.description}
            ctaHref={resource.href}
            ctaText="View details"
          />
          /* eslint-enable react/no-array-index-key */
        ))}
      </Columns>
    </PageContentBlock>
  );
};
